@if (isCompact) {
<aside class="pub-sidebar">
  <a [routerLink]="brandRoute" class="pub-sidebar__logo" (click)="closeMenu()" title="InstaLinker">
    <img src="/instalinker-logo.png" alt="InstaLinker" class="pub-sidebar__logo-img" />
  </a>

  <nav class="pub-sidebar__nav">
    <a routerLink="/" routerLinkActive="pub-sidebar__link--active" [routerLinkActiveOptions]="{ exact: true }"
      class="pub-sidebar__link" title="Home" data-index="01">
      <i class="fa-solid fa-house"></i>
    </a>
    <a routerLink="/stores" routerLinkActive="pub-sidebar__link--active" class="pub-sidebar__link" title="Stores" data-index="02">
      <i class="fa-solid fa-store"></i>
    </a>
    <a routerLink="/products" routerLinkActive="pub-sidebar__link--active" class="pub-sidebar__link" title="Products" data-index="03">
      <i class="fa-solid fa-box"></i>
    </a>
    <a routerLink="/explore" routerLinkActive="pub-sidebar__link--active" class="pub-sidebar__link" title="Explore" data-index="04">
      <i class="fa-solid fa-compass"></i>
    </a>
    <a routerLink="/about" routerLinkActive="pub-sidebar__link--active" class="pub-sidebar__link" title="About" data-index="05">
      <i class="fa-solid fa-circle-info"></i>
    </a>
  </nav>

  <div class="pub-sidebar__bottom">
    <button type="button" class="pub-sidebar__theme-btn" [class.is-dark]="themeService.isDark()" (click)="themeService.toggleTheme()" aria-label="Toggle theme" title="Toggle theme">
      <i class="fa-solid fa-circle-half-stroke"></i>
    </button>

    <button type="button" class="pub-sidebar__cart-btn" (click)="cartService.open()" aria-label="Open cart">
      <i class="fa-solid fa-bag-shopping"></i>
      @if (cartService.count() > 0) {
        <span class="pub-nav__cart-badge">{{ cartService.count() }}</span>
      }
    </button>

    <button type="button" (click)="toggleProfileMenu($event)" class="pub-sidebar__profile-btn"
      aria-label="Profile menu">
      <i class="fa-solid fa-user"></i>
    </button>

    @if (isProfileMenuOpen) {
    <div class="pub-nav__dropdown pub-nav__dropdown--sidebar" (click)="onProfileMenuClick($event)">
      <!-- User Profile Header -->
      @if (isLoggedIn()) {
      <div class="pub-nav__dropdown-header">
        <div class="pub-nav__avatar">
          <i class="fa-solid fa-user"></i>
        </div>
        <div class="pub-nav__user-details">
          <span class="pub-nav__user-name">{{ currentUser?.name || 'User' }}</span>
          <span class="pub-nav__user-email">{{ currentUser?.email }}</span>
        </div>
      </div>
      <div class="pub-nav__dropdown-divider"></div>

      <button type="button" (click)="onLogout()" class="pub-nav__dropdown-item pub-nav__dropdown-item--danger">
        <i class="fa-solid fa-right-from-bracket pub-nav__dropdown-icon"></i>
        <span>{{ logoutLabel }}</span>
      </button>
      } @else {
      <!-- Guest Header -->
      <div class="pub-nav__dropdown-header">
        <div class="pub-nav__avatar">
          <i class="fa-regular fa-user"></i>
        </div>
        <div class="pub-nav__user-details">
          <span class="pub-nav__user-name">Guest</span>
          <span class="pub-nav__user-email">Sign in to manage stores</span>
        </div>
      </div>
      <div class="pub-nav__dropdown-divider"></div>

      <a routerLink="/login" (click)="onProfileAction()" class="pub-nav__dropdown-item">
        <i class="fa-solid fa-right-to-bracket pub-nav__dropdown-icon"></i>
        <span>Login</span>
      </a>
      <a routerLink="/join-insta-linker" (click)="onProfileAction()"
        class="pub-nav__dropdown-item pub-nav__dropdown-item--cta">
        <i class="fa-solid fa-user-plus pub-nav__dropdown-icon"></i>
        <span>Get Started</span>
      </a>
      }
    </div>
    }
  </div>
</aside>
} @else {
<header class="pub-nav">
  <div class="pub-nav__inner">
    <!-- Brand -->
    <a [routerLink]="brandRoute" class="pub-nav__brand" (click)="closeMenu()">
      <div class="pub-nav__brand-logo">
        <img src="/instalinker-logo.png" alt="InstaLinker" class="pub-nav__brand-img" />
      </div>
      <span class="pub-nav__brand-name">Insta<span class="pub-nav__brand-linker">Linker</span></span>
    </a>

    <!-- Desktop nav links -->
    <nav class="pub-nav__links">
      <a routerLink="/" routerLinkActive="pub-nav__link--active" [routerLinkActiveOptions]="{ exact: true }"
        class="pub-nav__link">Home</a>
      <a routerLink="/stores" routerLinkActive="pub-nav__link--active" class="pub-nav__link">Stores</a>
      <a routerLink="/products" routerLinkActive="pub-nav__link--active" class="pub-nav__link">Products</a>
      <a routerLink="/explore" routerLinkActive="pub-nav__link--active" class="pub-nav__link">Explore</a>
      <a routerLink="/about" routerLinkActive="pub-nav__link--active" class="pub-nav__link">About</a>
      @if (!isLoggedIn()) {
      <a routerLink="/join-insta-linker" routerLinkActive="pub-nav__link--active" class="pub-nav__link">Join</a>
      }
    </nav>

    <!-- Right actions -->
    <div class="pub-nav__actions">
      <button type="button" class="pub-nav__theme-btn" [class.is-dark]="themeService.isDark()" (click)="themeService.toggleTheme()" aria-label="Toggle theme" title="Toggle theme">
        <i class="fa-solid fa-circle-half-stroke"></i>
      </button>

      <button type="button" class="pub-nav__cart-btn" (click)="cartService.open()" aria-label="Open cart">
        <i class="fa-solid fa-bag-shopping"></i>
        @if (cartService.count() > 0) {
          <span class="pub-nav__cart-badge">{{ cartService.count() }}</span>
        }
      </button>

      <div class="relative">
        <button type="button" (click)="toggleProfileMenu($event)" class="pub-nav__profile-btn"
          aria-label="Profile menu">
          <i class="fa-solid fa-user"></i>
        </button>

        @if (isProfileMenuOpen) {
        <div class="pub-nav__dropdown" (click)="onProfileMenuClick($event)">
          <!-- User Profile Header -->
          @if (isLoggedIn()) {
          <div class="pub-nav__dropdown-header">
            <div class="pub-nav__avatar">
              <i class="fa-solid fa-user"></i>
            </div>
            <div class="pub-nav__user-details">
              <span class="pub-nav__user-name">{{ currentUser?.name || 'User' }}</span>
              <span class="pub-nav__user-email">{{ currentUser?.email }}</span>
            </div>
          </div>
          <div class="pub-nav__dropdown-divider"></div>

          @if (showAdminNavTag) {
          <a [routerLink]="adminPortalRoute" (click)="onProfileAction()" class="pub-nav__dropdown-item">
            <i class="fa-solid fa-screwdriver-wrench pub-nav__dropdown-icon"></i>
            <span>Admin</span>
          </a>
          }

          <button type="button" (click)="onLogout()" class="pub-nav__dropdown-item pub-nav__dropdown-item--danger">
            <i class="fa-solid fa-right-from-bracket pub-nav__dropdown-icon"></i>
            <span>{{ logoutLabel }}</span>
          </button>
          } @else {
          <!-- Guest Header -->
          <div class="pub-nav__dropdown-header">
            <div class="pub-nav__avatar">
              <i class="fa-regular fa-user"></i>
            </div>
            <div class="pub-nav__user-details">
              <span class="pub-nav__user-name">Guest</span>
              <span class="pub-nav__user-email">Sign in to manage stores</span>
            </div>
          </div>
          <div class="pub-nav__dropdown-divider"></div>

          <a routerLink="/login" (click)="onProfileAction()" class="pub-nav__dropdown-item">
            <i class="fa-solid fa-right-to-bracket pub-nav__dropdown-icon"></i>
            <span>Login</span>
          </a>
          <a routerLink="/join-insta-linker" (click)="onProfileAction()"
            class="pub-nav__dropdown-item pub-nav__dropdown-item--cta">
            <i class="fa-solid fa-user-plus pub-nav__dropdown-icon"></i>
            <span>Get Started</span>
          </a>
          }
        </div>
        }
      </div>
    </div>
  </div>
</header>
}
